import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"

export const createAlert = createAsyncThunk(
  'alerts/createAlert',
  async ({ userId, message, type, expiresAt }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/alerts/users/${userId}`, {
        message,
        type,
        expiresAt
      })
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || 'Failed to create alert'
      return rejectWithValue(errorMessage)
    }
  }
)

export const getAlertsByUser = createAsyncThunk(
  'alerts/getAlertsByUser',
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/alerts/users/${userId}`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || 'Failed to fetch alerts'
      return rejectWithValue(errorMessage)
    }
  }
)

export const updateAlertById = createAsyncThunk(
  'alerts/updateAlertById',
  async ({ alertId, message, type, expiresAt }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.put(`/alerts/${alertId}`, {
        message,
        type,
        expiresAt
      })
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || 'Failed to update alert'
      return rejectWithValue(errorMessage)
    }
  }
)

export const deleteAlertById = createAsyncThunk(
  'alerts/deleteAlertById',
  async (alertId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.delete(`/alerts/${alertId}`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.error?.errors?.[0]?.message || 'Failed to delete alert'
      return rejectWithValue(errorMessage)
    }
  }
)
